export const AD_FORMATS = {
  APP_ONLY: 'App Only',
  DISPLAY: 'Cross-Platform Display',
  SEARCH: 'Cross-Platform Search',
  PRODUCT: 'Cross-Platform Product',
};

export const SECONDARY_AD_FORMATS = {
  FACEBOOK: {
    [AD_FORMATS.APP_ONLY]: ['App Engagement Ads', 'App Install Ads'],
  },
  OTHER: {},
};

export const OS_TYPES = {
  ANDROID: 'Android',
  IOS: 'iOS',
};

export const LINK_DATA_KEYS = {
  ALWAYS_DEEP_LINK: '$always_deeplink',
  ANDROID_DEEP_LINK_PATH: '$android_deeplink_path',
  ANDROID_PASSIVE_DEEPVIEW: '$android_passive_deepview',
  ANDROID_REDIRECT_TIMEOUT: '$android_redirect_timeout',
  ANDROID_URI_REDIRECT_MODE: '$android_uri_redirect_mode',
  ANDROID_WEB_CHAT_URL: '$android_wechat_url',
  BLACKBERRY_URL: '$blackberry_url',
  CANONICAL_IDENTIFIER: '$canonical_identifier',
  CANONICAL_URL: '$canonical_url',
  CLICK_CONVERSION_WINDOW_DAYS: '$click_conversion_window_days',
  CLICK_INSTALL_WINDOW_DAYS: '$click_install_window_days',
  CLICK_SESSION_START_WINDOW_DAYS: '$click_session_start_window_days',
  CONTENT_TYPE: '$content-type',
  CUSTOM_META_TAGS: '$custom_meta_tags',
  CUSTOM_SMS_TEXT: '$custom_sms_text',
  DEEP_LINK_PATH: '$deeplink_path',
  DEEPLINK_NO_ATTRIBUTION: '$deeplink_no_attribution',
  DESKTOP_DEEP_LINK_PATH: '$desktop_deeplink_path',
  DESKTOP_WEB_ONLY: '$desktop_web_only',
  DO_NOT_PROCESS: '$do_not_process',
  EXP_DATE: '$exp_date',
  FALLBACK_URL: '$fallback_url',
  FIRE_URL: '$fire_url',
  HUAWEI_URL: '$huawei_url',
  HOUSEHOLD_MEASUREMENT_WINDOW_DAYS: '$household_measurement_window_days',
  IMPRESSION_CONVERSION_WINDOW_DAYS: '$impression_conversion_window_days',
  IMPRESSION_INSTALL_WINDOW_DAYS: '$impression_install_window_days',
  IMPRESSION_SESSION_START_WINDOW_DAYS: '$impression_session_start_window_days',
  IOS_DEEP_LINK_PATH: '$ios_deeplink_path',
  IOS_NATIVE_LINK: '$ios_nativelink',
  IOS_PASSIVE_DEEPVIEW: '$ios_passive_deepview',
  IOS_REDIRECT_TIMEOUT: '$ios_redirect_timeout',
  IOS_URI_REDIRECT_MODE: '$ios_uri_redirect_mode',
  IOS_WEB_CHAT_URL: '$ios_wechat_url',
  IPAD_URL: '$ipad_url',
  MATCH_DURATION: '$match_duration',
  MOBILE_WEB_ONLY: '$mobile_web_only',
  OG_IMAGE_HEIGHT: '$og_image_height',
  OG_IMAGE_WIDTH: '$og_image_width',
  OG_REDIRECT: '$og_redirect',
  OG_TYPE: '$og_type',
  OG_URL: '$og_url',
  OG_VIDEO: '$og_video',
  PUBLICLY_INDEXABLE: '$publicly_indexable',
  SAMSUNG_URL: '$samsung_url',
  TWITTER_APP_COUNTRY: '$twitter_app_country',
  TWITTER_CARD: '$twitter_card',
  TWITTER_PLAYER: '$twitter_player',
  TWITTER_PLAYER_HEIGHT: '$twitter_player_height',
  TWITTER_PLAYER_WIDTH: '$twitter_player_width',
  TWITTER_SITE: '$twitter_site',
  URI_REDIRECT_MODE: '$uri_redirect_mode',
  WEB_ONLY: '$web_only',
  WINDOWS_PHONE_URL: '$windows_phone_url',
} as const;

export const IMPRESSION_PARAM_BLACKLIST = [
  '$link_title',
  '$one_time_use',
  '+url',
  '~id',
  '~advertising_partner_name',
  '~os_type',
  '$always_deeplink',
  '$android_deeplink_path',
  '$android_passive_deepview',
  '$android_redirect_timeout',
  '$android_wechat_url',
  '$blackberry_ur',
  '$click_conversion_window_days',
  '$click_install_window_days',
  '$click_session_start_window_days',
  '$custom_sms_text',
  '$deeplink_no_attribution',
  '$deeplink_path',
  '$desktop_deeplink_path',
  '$do_not_process',
  '$fallback_url',
  '$fire_url',
  '$ios_deeplink_path',
  '$ios_passive_deepview',
  '$ios_redirect_timeout',
  '$ios_wechat_url',
  '$ipad_url',
  '$match_duration',
  '$og_image_height',
  '$og_image_width',
  '$og_redirect',
  '$og_type',
  '$og_url',
  '$og_video',
  '$publicly_indexable',
  '$samsung_url',
  '$twitter_app_country',
  '$twitter_card',
  '$twitter_player_height',
  '$twitter_player_width',
  '$twitter_player',
  '$twitter_site',
  '$uri_redirect_mode',
  '$web_only',
  '$windows_phone_url',
  '~creation_source',
];
